import { render, staticRenderFns } from "./form1.vue?vue&type=template&id=5faee84e&scoped=true"
import script from "./form1.vue?vue&type=script&lang=js"
export * from "./form1.vue?vue&type=script&lang=js"
import style0 from "./form1.vue?vue&type=style&index=0&id=5faee84e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faee84e",
  null
  
)

export default component.exports